import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { CUSTOM_FIELD_TEMPLATES_QUERY } from "../constants/graphql/queries";

export default function useConfigurableFields({ skip } = {}) {
  const data = useQuery(CUSTOM_FIELD_TEMPLATES_QUERY, {
    fetchPolicy: "cache-first",
    skip,
  });

  const value = useMemo(() => {
    const customFields = data?.data?.customFieldTemplates || [];
    const configurableFields = customFields.map(template => [
      `custom_field_${template.id}`,
      "custom",
      template.defaultLabel,
    ]);

    return { ...data, customFields, configurableFields };
  }, [data]);

  return value;
}
